import api from '@/utils/api';

/**
 * Update company option
 * @param {string} companyId - Company Id
 * @returns {Promise}
 */
const getCompanyTemplatesApi = (companyId) => (query) => {
  const queryString = query ? `?${query}` : '';
  return api.get(`company/${companyId}/template${queryString}`);
};

export default getCompanyTemplatesApi;
